module.exports = __webpack_public_path__ + "static/media/1009892.94da47bb.jpg";